// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xCarbonStainlessFilterStateType = Readonly<{
    selectedValue?: string;
}>;

export const initialxCarbonStainlessFilterState: xCarbonStainlessFilterStateType = {
    selectedValue: undefined,
};

const reducer = {
    "xCarbonStainlessFilter/setSelectedValue": (
        draft: Draft<xCarbonStainlessFilterStateType>,
        action: { selectedValue?: string },
    ) => {
        draft.selectedValue = action.selectedValue;
    },
};

const xCarbonStainlessFilter = createTypedReducerWithImmer(initialxCarbonStainlessFilterState, reducer);

(reducers as any).xCarbonStainlessFilter = xCarbonStainlessFilter;

export type xCarbonStainlessFilterState = {
    xCarbonStainlessFilter: xCarbonStainlessFilterStateType;
} & ApplicationState;

type xCarbonStainlessFilterReducers = {
    [key: string]: typeof xCarbonStainlessFilter;
};

export type xCarbonStainlessFilterActions =
    | Parameters<xCarbonStainlessFilterReducers[keyof xCarbonStainlessFilterReducers]>[1]
    | AnyAction;
